import linq from 'linq'
import { snakeToCamel, camelToSnake } from '../utility/stringUtility'
import Form from 'vform'
import { arrayWrap } from '../utility/arrayUtitlity'
import CollectionTableSet from './CollectionTableSet'

const FILLABEL = ['id', 'name']

export default class TableSet {
    constructor(data = null) {
        this.originalData = data

        this.id = 0
        this.name = ''

        this.collectionTableSet = new CollectionTableSet()

        this.form = new Form()

        if (data) {
            this.create()
        }
    }

    get _model() {
        return 'TableSet'
    }

    create() {
        linq.from(this.data)
            .select((x) => {
                x.key = camelToSnake(x.key)
                return x
            })
            .where((x) => this.hasOwnProperty(snakeToCamel(x.key)))
            .select((x) => {
                const key = snakeToCamel(x.key)

                if (typeof this[key] === 'collection_table_set') {
                    this[key] = new CollectionTableSet(x.value)
                    return
                }

                this[key] = x.value
                return x
            })
            .toArray()
    }

    get data() {
        return this.originalData
    }

    get hasError() {
        return Object.keys(this.form.errors.errors).length
    }

    get errors() {
        return linq
            .from(this.form.errors.errors)
            .select((x) => {
                return arrayWrap(x.value)[0]
            })
            .toArray()
    }

    getPostable() {
        return linq
            .from(this)
            .where((x) => linq.from(FILLABEL).any((xs) => xs === x.key))
            .where((x) => x.value)
            .select((x) => {
                return {
                    key: camelToSnake(x.key),
                    value: x.value,
                }
            })
            .toObject('$.key', '$.value')
    }

    fill() {
        this.form = new Form(this.getPostable())
    }

    async post(url) {
        this.fill()
        return await this.form.post(url)
    }

    async delete(url) {
        this.fill()
        return await this.form.delete(url)
    }

    async patch(url) {
        this.fill()
        return await this.form.patch(url)
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/models/TableSet.js